import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "lang" }
const _hoisted_4 = { class: "tag-list" }
const _hoisted_5 = { class: "manage" }

import { computed, onBeforeMount, onMounted } from 'vue';
import PlaySVG from './components/svg/PlaySVG.vue'
import StopSVG from './components/svg/StopSVG.vue'
import ResetSVG from './components/svg/ResetSVG.vue'

import Timer from './timer'
import TagComponent from './components/TagComponent.vue';
import Card from './components/Card.vue'
import loc from './locales';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const intervals = [
  [20, 5],
  [25, 5],
  [30, 10],
  [40, 20],
  [45, 15]
]


function updateOptions(index: number) {
  Timer.options.workTime = intervals[index][0] * 60
  Timer.options.breakTime = intervals[index][1] * 60
  Timer.reset()
}

const value = computed(() => {
  const max = Timer.isBreakTime ? Timer.options.breakTime : Timer.options.workTime
  const current = Timer.currentCounter.value
  return 1 - Math.floor((current/max) * 100) / 100
})

onBeforeMount(() => {
  updateOptions(0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass({active: _unref(loc).lang === 'en'}),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(loc).setLocale('en')))
        }, "English", 2),
        _createElementVNode("span", {
          class: _normalizeClass({active: _unref(loc).lang === 'ru'}),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(loc).setLocale('ru')))
        }, "Русский", 2)
      ]),
      _createVNode(Card, {
        value: _unref(value),
        seconds: _unref(Timer).currentCounter.value,
        isBreakTime: _unref(Timer).isBreakTime,
        state: _unref(Timer).state.value
      }, null, 8, ["value", "seconds", "isBreakTime", "state"]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(intervals, (item, index) => {
          return _createVNode(TagComponent, {
            onClick: ($event: any) => (updateOptions(index)),
            key: index
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item[0]) + "/" + _toDisplayString(item[1]), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(Timer).state.value === 'stopping' || _unref(Timer).state.value === 'suspended')
          ? (_openBlock(), _createBlock(PlaySVG, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(Timer).start())),
              fill: "white"
            }))
          : (_openBlock(), _createBlock(StopSVG, {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(Timer).stop())),
              fill: "white"
            })),
        _createVNode(ResetSVG, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(Timer).reset())),
          fill: "white"
        })
      ])
    ])
  ]))
}
}

})